import styled from "styled-components";

const StyledAddPaymentMethod = styled.div`
	.sb-add-payment-method {
	}
`;

export default StyledAddPaymentMethod;
